<template>
  <v-layout row>
    <v-flex xs12 sm12>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Audit Report</v-toolbar-title>
        </v-toolbar>
        <v-list>
          <template v-for="(item, index) in audit_analysis">
            <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
            <v-list-tile v-else-if="item.field==='scope'" :key="item.field" avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.description"></v-list-tile-title>
                <v-list-tile-sub-title v-if="item.value">
                  <SnippetScope :scope="item.value" />
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else-if="item.field==='leadauditor'" :key="item.field" avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.description"></v-list-tile-title>
                <v-list-tile-sub-title v-if="item.value">
                  <SnippetUser :currentUsers="item.value" />
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else-if="item.field==='standard'" :key="item.field">
              <v-list-tile-content>
                <v-list-tile-title v-html="item.description"></v-list-tile-title>
                <v-list-tile-sub-title v-if="item.value">{{item.value.join(", ") }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else :key="item.field" avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.description"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.value"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import SnippetScope from "@/components/snippets/SnippetScope.vue";
import SnippetUser from "@/components/snippets/SnippetUser.vue";

export default {
  props: {
    auditanalysis: { type: Array }
  },
  data: () => ({}),
  computed: {
    audit_analysis() {
      return this.auditanalysis;
    }
  },
  components: {
    SnippetScope,
    SnippetUser
  }
};
</script>
